import React, { Component } from "react";
import _ from "underscore";
import { withStyles } from "material-ui/styles";

import { fade } from "material-ui/styles/colorManipulator";
import { DropTarget } from "react-dnd";
import Icon from "material-ui/Icon";
import getDndContext from "components/DndContext";
import ItemTypes from "./ItemTypes";
import Attr from "./Attr";

const styles = {
  addButton: {
    border: "1px dashed gray",
    padding: "0.5rem 1rem",
    marginBottom: ".5rem",
    backgroundColor: "white",
    cursor: "pointer",
    outline: "none",
    "&:hover": {
      backgroundColor: fade("#26a69a", 0.1),
      // Reset on mouse devices
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }
  }
};

const itemTarget = {
  drop() {}
};

const dropTarget = connect => ({
  connectDropTarget: connect.dropTarget()
});

class Container extends Component {
  moveAttr(id, atIndex) {
    const { attr, index } = this.findAttr(id);
    this.props.changeAttrOrder(attr, index, atIndex);
  }

  findAttr(id) {
    const { attrs } = this.props;
    const attr = attrs.filter(c => c.id === id)[0];
    return {
      attr,
      index: attrs.indexOf(attr)
    };
  }
  addButton(openModal, classes) {
    return (
      <div
        role="button"
        id="addButton"
        tabIndex={0}
        onClick={() => openModal()}
        onKeyPress={() => openModal()}
        className={classes.addButton}
        style={{ textAlign: "center" }}
      >
        <Icon style={{ verticalAlign: "sub", fontSize: 20 }}>add</Icon>
        <span>（追加）</span>
      </div>
    );
  }

  itemsButtons(
    attrs,
    localeNo,
    changeUseAttrs,
    openModal,
    moveAttr,
    removeAttr,
    classes
  ) {
    return (
      <div>
        {attrs.length > 0 &&
          attrs.map((attr, i) => (
            <Attr
              key={attr.id}
              id={attr.id}
              index={i + 1}
              title={attr.locale[localeNo].attrName}
              attrItemLabels={_.pluck(
                attr.locale[localeNo].attrItems,
                "itemName"
              ).join("、 ")}
              findAttr={id => this.findAttr(id)}
              moveAttr={(id, index) => this.moveAttr(id, index)}
              removeAttr={index => removeAttr(index)}
              openModal={id => openModal(id)}
              classes={classes}
              preset={!!attr.presetFlg}
            />
          ))}
      </div>
    );
  }

  render() {
    const { connectDropTarget, changeUseAttrs, localeNo, classes } = this.props;
    return (
      <div>
        {connectDropTarget(
          this.itemsButtons(
            this.props.attrs,
            localeNo,
            changeUseAttrs,
            this.props.openEditAttrModal,
            this.props.changeAttrOrder,
            this.props.removeAttr,
            classes
          )
        )}
        {this.props.attrs.length < 10 &&
          this.addButton(this.props.openEditAttrModal, classes)}
      </div>
    );
  }
}

export default getDndContext()(
  DropTarget(ItemTypes.ATTR, itemTarget, dropTarget)(
    withStyles(styles)(Container)
  )
);



// WEBPACK FOOTER //
// ./src/components/SetupAttr/Container.jsx